import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import "../styles/Login.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Admin routing configuration based on company name
  // Note: Company names will be compared case-insensitively
  const adminRoutes = {
    "sarathchandra textile": "/txtsadmin",
    "centauria lake": "/admin",
    // Add more company names and their specific routes
    // "Company Name": "/their/specific/route"
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      const token = await user.getIdToken();
      const userDoc = await getDoc(doc(db, "users", user.uid));

      if (!userDoc.exists()) {
        throw new Error("User record not found in database.");
      }

      const userData = userDoc.data();
      const role = userData.role || "user";
      const company = userData.company || "";

      localStorage.setItem("authToken", token);
      localStorage.setItem("role", role);
      localStorage.setItem("company", company);

      // If role is admin, check company and route accordingly
      if (role === "admin") {
        console.log("Admin login detected");
        console.log("Company:", company);

        // Normalize company name for case-insensitive comparison
        const normalizedCompany = company.toLowerCase().trim();
        const specificRoute = adminRoutes[normalizedCompany];

        console.log("Normalized company:", normalizedCompany);
        console.log("Matched route:", specificRoute || "default /admin");

        if (specificRoute) {
          // Navigate to company-specific admin page
          console.log(`✓ Routing admin from ${company} to ${specificRoute}`);
          navigate(specificRoute, {
            state: {
              company,
              userData
            }
          });
        } else {
          // Navigate to default admin page
          console.log(`Admin from ${company} using default admin page`);
          navigate("/admin", {
            state: {
              company,
              userData
            }
          });
        }
      } else if (role === "Superadmin") {
        navigate("/superadmin");
      } else if (role === "security") {
        navigate("/securitydash");
      } else if (role === "driver") {
        navigate("/driverdash");
      } else {
        navigate("/user");
      }
    } catch (err) {
      console.error("Login failed:", err.message);

      // Clean up Firebase error message
      let cleanMessage = err.message.replace("Firebase: ", "").trim();

      setError(cleanMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-background">
      <div className="login-container">
        <form onSubmit={handleLogin} className="login-form">
          {/* <img 
            src="/hotels.png"  // replace with your actual logo path
            alt="Hotel Logo" 
            className="hotel-logo"
          /> */}

          <h1 className="title">Bizora</h1>

          {error && <p className="error-text">{error}</p>}
          <input
            type="email"
            placeholder="Username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <p style={{ color: "blue" }}>
            <a href="#">Forgot Your Password?</a>
          </p>
          <button type="submit" disabled={loading} className="login-button">
            {loading ? <span className="spinner" /> : "Login"}
          </button>
          {/* <p className="center-text">Centauria IT Division.</p> */}
        </form>
      </div>
    </div>
  );
}

export default Login;